import {
  InternalOrganizationBillingCurrentPlanType,
  InternalOrganizationBillingSubscriptionType,
} from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { BILLING_FREQUENCY_LABEL } from '@/const/shared';
import { isCancelledSubscriptionStatus, isMonthlyFrequency, isSingleUsePaymentPlan } from '@/helpers/billingHelpers';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { convertCentsToDollars } from '@/helpers/formatHelpers';
import capitalize from 'lodash/capitalize';

export const getBillingPriceLabel = (planDetails: InternalOrganizationBillingCurrentPlanType) => {
  if (!planDetails) return;

  const { schedule_type, billing_frequency } = planDetails;

  if (isSingleUsePaymentPlan(schedule_type)) {
    return 'Total';
  }

  return isMonthlyFrequency(billing_frequency) ? 'Total per month' : 'Total per year';
};

export const getBillingPrice = (planDetails: InternalOrganizationBillingCurrentPlanType) => {
  if (!planDetails) return;

  const { schedule_type, interval_price_amount, extra_view_price_amount } = planDetails;

  const price = isSingleUsePaymentPlan(schedule_type) ? extra_view_price_amount : interval_price_amount;

  return convertCentsToDollars(price);
};

export const getBillingFrequencyLabel = (planDetails: InternalOrganizationBillingCurrentPlanType) => {
  if (!planDetails) return;

  const { schedule_type, billing_frequency } = planDetails;

  if (isSingleUsePaymentPlan(schedule_type)) {
    return 'Single Use';
  }

  return capitalize(BILLING_FREQUENCY_LABEL[billing_frequency]);
};

export const getCancellationDateLabel = (
  subscription: InternalOrganizationBillingSubscriptionType,
  isPendingCancellationSubscription: boolean
) => {
  if (!subscription) return;

  const isCancelledSubscription = isCancelledSubscriptionStatus(subscription.status);

  if (isCancelledSubscription) {
    return `Cancelled on ${formatDate(subscription.date_canceled)}`;
  }

  if (isPendingCancellationSubscription) {
    return `Scheduled to cancel on ${formatDate(subscription.current_period_end)}`;
  }
};

export const getBillingCycleLabel = (
  subscription: InternalOrganizationBillingSubscriptionType,
  isPendingCancellationSubscription: boolean
) => {
  if (!subscription) return;

  const isCancelledSubscription = isCancelledSubscriptionStatus(subscription.status);
  const nextBillingDate = formatDate(subscription.current_period_end);

  if (isCancelledSubscription) {
    return `Ended on ${nextBillingDate}`;
  }

  if (isPendingCancellationSubscription) {
    return `Ends ${nextBillingDate}`;
  }

  return `Renews ${nextBillingDate}`;
};
